import {Routes} from '@angular/router';

import {DashboardComponent} from '../../dashboard/dashboard.component';
import {TableListComponent} from '../../table-list/table-list.component';
import {TypographyComponent} from '../../typography/typography.component';
import {IconsComponent} from '../../icons/icons.component';
import {AuthGuard} from '../../login/guards/auth.guard';
import {OffresComponent} from '../../offres/offres.component';
import {PubComponent} from '../../pub/pub.component';
import {FeedbackComponent} from '../../feed-back/feedback.component';
import {TagsComponent} from '../../tags/tags.component';
import {GestionClientComponent} from '../../user-profile/gestion-client/gestion-client.component';
import {GestionPartenaireComponent} from '../../user-profile/gestion-partenaire/gestion-partenaire.component';
import {DetailClientComponent} from '../../user-profile/gestion-client/detail-client/detail-client.component';
import {DetailPartenaireComponent} from '../../user-profile/gestion-partenaire/detail-partenaire/detail-partenaire.component';
import {UserProfileComponent} from '../../user-profile/user-profile.component';
import {CategoryComponent} from '../../category/category.component';
import {DetailDashboardComponent} from '../../dashboard/detail-dashboard/detail-dashboard.component';
import {ContactUsComponent} from '../../contact-us/contact-us.component';
import {CouponManagmentComponent} from '../../coupon-managment/coupon-managment.component';

export const AdminLayoutRoutes: Routes = [
    {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
    {path: 'dashboard/detail-dashboard/:chartName', component: DetailDashboardComponent, canActivate: [AuthGuard]},
    {path: 'customers', component: GestionClientComponent, canActivate: [AuthGuard]},
    {path: 'customers/:clientUuid', component: DetailClientComponent, canActivate: [AuthGuard]},
    {path: 'partners', component: GestionPartenaireComponent, canActivate: [AuthGuard]},
    {path: 'partners/:partnerUuid', component: DetailPartenaireComponent, canActivate: [AuthGuard]},
    {path: 'offers', component: OffresComponent, canActivate: [AuthGuard]},
    {path: 'pub', component: PubComponent, canActivate: [AuthGuard]},
    {path: 'feed-back', component: FeedbackComponent, canActivate: [AuthGuard]},
    {path: 'categories', component: CategoryComponent, canActivate: [AuthGuard]},
    {path: 'contact-us', component: ContactUsComponent, canActivate: [AuthGuard]},
    {path: 'coupons', component: CouponManagmentComponent, canActivate: [AuthGuard]},
    {path: 'profile', component: UserProfileComponent, canActivate: [AuthGuard]},
    {path: 'tags', component: TagsComponent, canActivate: [AuthGuard]},
    {path: 'table-list', component: TableListComponent},
    {path: 'typography', component: TypographyComponent},
    {path: 'icons', component: IconsComponent}
];
